import { useState } from 'react'
import {
  ContentBody,
  Table,
  AccompanimentsForm,
  Menu,
  MenuItem,
  SugestionAndComplaintsForm,
  DropdownButton
} from '../../../../core/components'

const uploadDefaultValues = { fileList: [], uploading: false }

import { useParams } from 'react-router-dom'
import { Pagination } from '../../../../entities'
import useCustomerAccompaniments from '../../../../services/queries/customer/useCustomerAccompaniments'
import { dateFormat } from '../../../../utils/format/dateFormat'
import { createAccompaniments } from '../../../../services'
import { DownOutlined, PlusOutlined } from '@ant-design/icons'

export const AccompanimentsTab = () => {
  const [state, setState] = useState<any>(uploadDefaultValues)
  const [isAccompanimentsModalVisible, setIsAccompanimentsModalVisible] =
    useState(false)
  const [
    isSugestionAndComplaintsModalVisible,
    setIsSugestionAndComplaintsModalVisible
  ] = useState(false)

  const { id }: any = useParams()
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const { data, error, isLoading }: any = useCustomerAccompaniments({
    ...pagination,
    id
  })
  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const handleUpload = async () => {
    const { fileList } = state
    const formData = new FormData()

    formData.append('to', state.to)
    formData.append('copy', state.copy)
    formData.append('subject', state.subject)
    formData.append('description', state.description)
    formData.append('titleId', state.titleId)
    // formData.append('situation', '30')
    formData.append('companyId', id)

    fileList.forEach((file: any) => {
      formData.append('attachments', file)
    })

    await createAccompaniments(formData)

    setState((prev: any) => ({ ...prev, uploading: true }))
  }

  const showAccompanimentsModal = () => {
    setIsAccompanimentsModalVisible(true)
  }

  const showSugestionAndComplaintsModal = () => {
    setIsSugestionAndComplaintsModalVisible(true)
  }

  const handleAccompanimentsOk = async () => {
    await handleUpload()
    setIsAccompanimentsModalVisible(false)
  }

  const handleSugestionAndComplaintsVisibleOk = async () => {
    await handleUpload()
    setIsSugestionAndComplaintsModalVisible(false)
  }

  const handleAccompanimentsCancel = () => {
    setIsAccompanimentsModalVisible(false)
    setState(uploadDefaultValues)
  }

  const handleSugestionAndComplaintsVisibleCancel = () => {
    setIsSugestionAndComplaintsModalVisible(false)
    setState(uploadDefaultValues)
  }

  const columns = [
    {
      title: 'Assunto',
      dataIndex: 'subject',
      key: 'subject'
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: 'Data',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value: string) => dateFormat(value)
    }
  ]

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  function handleMenuClick(e: any) {
    console.log('click', e)
  }

  const menu = (
    <Menu onClick={handleMenuClick}>
      <MenuItem key="1" onClick={showAccompanimentsModal}>
        Acompanhamentos
      </MenuItem>
      <MenuItem key="2" onClick={showSugestionAndComplaintsModal}>
        Sugestões e Reclamações
      </MenuItem>
    </Menu>
  )

  return (
    <>
      <ContentBody>
        <DropdownButton
          onClick={showAccompanimentsModal}
          type="primary"
          icon={<DownOutlined />}
          overlay={menu}
        >
          <PlusOutlined /> Novo
        </DropdownButton>
        {isAccompanimentsModalVisible && (
          <AccompanimentsForm
            visible={isAccompanimentsModalVisible}
            onCancel={handleAccompanimentsCancel}
            onOk={handleAccompanimentsOk}
            state={state}
            setState={setState}
          />
        )}
        {isSugestionAndComplaintsModalVisible && (
          <SugestionAndComplaintsForm
            visible={isSugestionAndComplaintsModalVisible}
            onCancel={handleSugestionAndComplaintsVisibleCancel}
            onOk={handleSugestionAndComplaintsVisibleOk}
            state={state}
            setState={setState}
          />
        )}
        <div style={{ height: 20 }} />
        <Table
          columns={columns}
          dataSource={data?.data}
          bordered
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
        />
      </ContentBody>
    </>
  )
}
